(function ($, Drupal) {
    Drupal.behaviors.clickWizardPageButton = {
        attach: function (context, settings) {
            
            function goToHomepage() {
                // Redirect to the promotion page
                var waveSettings = drupalSettings.laysNlngWaveSettings || {};
                var promotionUrl = waveSettings.gamePromotionUrl || '/';

                window.location.href = promotionUrl;
            }
            function goToContinuePage() {
                // Redirect to the continue page
                var waveSettings = drupalSettings.laysNlngWaveSettings || {};
                var continueUrl = waveSettings.gameConfirmationUrl || '/';

                window.location.href = continueUrl;
            }
            function clickOnWizardPageButton() {
                // Select the confirmation and address buttons within the "game-page-main" div
                const confirmationButtons = $('.game-page-main [data-webform-wizard-page="webform_confirmation"]');
                const addressButtons = $('.game-page-main [data-webform-wizard-page="address_page"]');

                // Validate that only one wizard page button exists
                if (confirmationButtons.length > 0 && addressButtons.length > 0) {
                    console.log('Multiple special wizard page types found. Action stopped.');
                    return;
                }

                // Determine which button to click
                let targetButton;
                if (confirmationButtons.length === 1) {
                    targetButton = confirmationButtons.first();
                } else if (addressButtons.length === 1) {
                    targetButton = addressButtons.first();
                } else {
                    console.log('No unique special wizard page button found.');
                    return;
                }

                targetButton.trigger('touchstart').trigger('touchend').trigger('click');
            }

            const iframeCall = (evt) => {
                // Validate the origin of the message for security
                if (evt.origin === 'https://pepsico-ucl-sitelays-acc.lwdev.nl' || evt.origin === 'https://pepsico-ucl-sitelays.lwprod.nl') {

                    if (evt.data) {
                        switch (evt.data.action) {
                            case 'callShareWithFriend':
                                // TBD
                                clickOnWizardPageButton();
                                break;
                            case 'callGoToHomepage':
                                goToHomepage();
                                break;
                            case 'callClaimPrize':
                                clickOnWizardPageButton();
                                break;
                            case 'callContinue':
                                goToContinuePage();
                                break;
                            default:
                                console.warn('Unrecognized action:' + evt.data.action);
                                break;
                        }
                    }
                } else {
                    // Ensure the message contains the expected structure
                    console.warn('Unauthorized message origin:', evt.origin);
                }
            };


            // Check if the function is called within a div with the class "game-page-main"
            if ($(context).find('.game-page-main').length) {
                // Add event listener for messages from the iframe
                window.addEventListener('message', iframeCall);
            }

        }
    };
})(jQuery, Drupal);